export interface IAuthResponse {
  data: {
    accessToken: string;
    expiresIn: number;
  };
  hasError: false;
  error: null;
}

export interface IUserInfoResponse {
  data: IUser;
  hasError: false;
  error: null;
}

export interface IUser {
  accessStatus?: 'Active' | 'Pending' | 'Revoked';
  canManageFranchiseAccess?: boolean;
  role?: string;
  franchiseId?: string;
  name: string;
  email: string;
  username: string;
  sector: string;
  groups: string[];
}

export enum IAtuhEnum {
  FRANCHISE_ADMIN = 'FRANCHISE_ADMIN',
  ADMIN = 'ADMIN',
  ADMIN_CODE = '03600360',
}
